<template>
  <div
    :class="[
      'asc-timeline-filter',
      menu ? 'asc-timeline-filter--expanded' : '',
    ]"
  >
    <v-menu v-model="menu" offset-y :close-on-content-click="false">
      <template #activator="{ on }">
        <v-btn
          class="asc-timeline-filter--toggle-button"
          text
          @click="on.click"
        >
          <v-icon :size="16"> mdi-calendar-blank </v-icon>
        </v-btn>
      </template>

      <div class="asc-timeline-filter--menu-content">
        <div class="asc-timeline-filter--menu-content--label">
          <asc-label uppercase value="Timeline"></asc-label>
        </div>
        <asc-segmented-button
          :selected-index="tempToggleIndex"
          :button-list="buttonList"
          :on-change="handleButtonToggle"
        ></asc-segmented-button>
      </div>

      <div class="asc-timeline-filter--button-container">
        <asc-accent-button
          button-text="Apply Filters"
          :on-click="handleApplyFilters"
        ></asc-accent-button>
      </div>
    </v-menu>
    <div class="asc-timeline-filter--content">
      <span class="asc-timeline-filter--content-text">{{ getFilterText }}</span>
    </div>
  </div>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscLabel from '@/components/atoms/AscLabel'
import AscSegmentedButton from '@/components/atoms/AscSegmentedButton'

export default {
  name: 'AscTimelineFilter',

  components: {
    AscAccentButton,
    AscLabel,
    AscSegmentedButton,
  },

  props: {
    optionFilter: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      menu: false,
      tempToggleIndex: this.optionFilter?.timelineIndex || 0,
      toggleIndex: this.optionFilter?.timelineIndex || 0,
      buttonList: [
        {
          index: 0,
          text: '1w',
          caption: '1 Week',
        },
        {
          index: 1,
          text: '2w',
          caption: '2 Weeks',
        },
        {
          index: 2,
          text: '1m',
          caption: '1 Month',
        },
        {
          index: 3,
          text: '3m',
          caption: '3 Months',
        },
        {
          index: 4,
          text: '6m',
          caption: '6 Months',
        },
        // {
        //   index: 5,
        //   text: '1y',
        //   caption: '1 Year',
        // },
      ],
    }
  },

  computed: {
    getFilterText() {
      const [item] = this.buttonList.filter(
        item => item.index === this.toggleIndex,
      )

      return item ? item.caption : '1 Week'
    },
  },

  methods: {
    handleButtonToggle(index) {
      this.tempToggleIndex = index
    },

    handleApplyFilters() {
      this.menu = false
      this.toggleIndex = this.tempToggleIndex
      this.handleInput()
    },

    handleInput() {
      const [button] = this.buttonList.filter(
        item => item.index === this.toggleIndex,
      )
      if (button) {
        const data = {
          timelineIndex: this.toggleIndex,
          timelineText: button.text,
        }
        this.$emit('filterChanged', data)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-timeline-filter {
  display: flex;

  &--toggle-button {
    border: 1px solid $gray-400;
    background-color: $primary-white !important;
    height: 32px !important;
    width: 32px !important;
    max-width: 32px !important;
    min-width: 32px !important;
    border-radius: 0 !important;

    .v-icon {
      color: $accent-600 !important;
    }

    &:hover {
      background-color: $accent-200 !important;
    }
  }

  &--content {
    margin-left: 8px;
    height: 32px;
    background-color: $gray-100;
    width: 72px;
    text-align: center;

    .asc-timeline-filter--content-text {
      display: inline-block;
      line-height: 32px;
      font-size: 14px;
    }
  }
}

.asc-timeline-filter--expanded {
  .asc-timeline-filter--toggle-button {
    background-color: $accent-100 !important;

    .v-icon {
      color: $accent-600 !important;
    }
  }
}

.asc-timeline-filter--menu-content {
  background-color: $primary-white;
  padding: 16px;

  .asc-timeline-filter--menu-content--label {
    margin-bottom: 8px;
  }
}

.asc-timeline-filter--button-container {
  border-top: 1px solid $gray-300;
  background-color: $primary-white;

  .asc-accent-button-container {
    padding: 16px 0;
    margin: 0 16px;

    .asc-accent-button--accent {
      width: 100%;
    }
  }
}
</style>
